import {useEffect, useRef, useState} from 'react';
import styled from '@emotion/styled/macro';
import { ReactComponent as ArrowDown } from '../../../img/arrow-down.svg';
import { ReactComponent as SquareUnchecked } from '../../../img/square-unchecked.svg';
import { ReactComponent as SquareChecked } from '../../../img/square-checked.svg';

const DropdownFilterContainer = styled.div`
    position: relative;

    & > button {
        background: none;
        border: 1px solid #000;
        border-radius: 4px;
        align-items: center;
        display: flex;
        font-size: 1rem;
        padding: 1rem 1.25rem;
    }
    & > button > svg:first-of-type {
        margin-right: 1.125rem;
    }
    & > button > svg:last-of-type {
        margin-left: 1.125rem;
    }

    &.active > ul {
        display: block;
    }
`

const DropdownList = styled.ul`
    background: #fff;
    border: 1px solid #000;
    border-radius: 4px;
    display: none;
    list-style: none;
    margin: 0.5rem 0 0 0;
    padding: 0;
    position: absolute;
    width: 100%;
    z-index: 1;
`

const DropdownInput = styled.li`
    align-items: center;
    display: flex;
    padding: 1rem;
    position: relative;

    & input {
        height: 100%;
        margin: 0;
        opacity: 0;
        position: absolute;
        width: 100%;
    }

    & label {
      margin-left: 0.5rem;
      text-transform: capitalize;
    }
`

interface DropdownFilterProps {

  handleChange: React.ChangeEventHandler;
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement> & { title?: string | undefined; }>;
  inputs: string[];
  label: string;
  value: string[];
}

export default function DropdownFilter({
    handleChange,
    icon: Icon,
    inputs,
    label,
    value
}: DropdownFilterProps) {
    const [isActive, toggleIsActive] = useState(false);

    const htmlElem = useRef<HTMLDivElement>(null);
    useEffect( () => {
        const eventListener = (ev: MouseEvent) => {
            const domElement = htmlElem.current;
            if (domElement === null || ev.target === null) {
                return;
            }
            if (!domElement.contains(ev.target as Node)) {
                console.log('click outside');
                toggleIsActive(false);
            }
        }
        document.addEventListener('click', eventListener);

        return () => {
            document.removeEventListener('click', eventListener);
        }
    });

    return (
        <DropdownFilterContainer ref={htmlElem} className={isActive ? "active" : ""}>
            <button onClick={() => toggleIsActive(!isActive)}>
                <Icon />
                {label}
                <ArrowDown />
            </button>
            <DropdownList>
                {inputs.map((inputValue) => (
                    <DropdownInput key={inputValue}>
                        <input
                            checked={value.includes(inputValue)}
                            id={inputValue}
                            name={label}
                            onChange={(ev: React.ChangeEvent) => { handleChange(ev);}}
                            type="checkbox"
                            value={inputValue}
                        />
                        {value.includes(inputValue) ? (
                            <SquareChecked />
                        ) : (
                            <SquareUnchecked />
                        )}
                        <label htmlFor={inputValue}>
                            {inputValue}
                        </label>
                    </DropdownInput>
                ))}
            </DropdownList>
        </DropdownFilterContainer>
    );
}
